import { render, staticRenderFns } from "./MediaForm.vue?vue&type=template&id=a74da964&"
import script from "./MediaForm.vue?vue&type=script&lang=js&"
export * from "./MediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports